export async function getSkuById(skuId) {
    try {
        const response = await fetch(`${process.env.REACT_APP_BASEURL_API_SPYNE}/3d/api/v2/sku/getById?sku_id=${skuId}`);
        
        if (!response.ok) {
            throw new Error(`API request failed with status ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching SKU data:', error);
        throw error;
    }
} 